export default "__VITE_ASSET__IzSSZv8I__"